export default {
  "rowSelection": false,
  "title": "质保金明细",
  "fieldControl": false,
  "columns": [
    {
      "title": "流水号",
      "dataIndex": "serialNumber",
      "width": 100
    },
    {
      "title": "发生时间",
      "dataIndex": "createdTime",
      "itemType": "dateTime",
      "width": 150
    },
    {
      "title": "同步单号",
      "dataIndex": "kingDeeCode",
      "width": 100,
    },
    {
      "title": "同步状态",
      "dataIndex": "syncStatusName",
      "width": 100,
    },
    {
      "title": "金额(¥)",
      "dataIndex": "amount",
      "render": "setAmount",
      "width": 100
    },
    {
      "title": "流水类型",
      "dataIndex": "changeTypeName",
      "width": 100
    },
    {
      "title": "流水状态",
      "dataIndex": "statusName",
      "width": 100
    },
    {
      "title": "操作人",
      "dataIndex": "createdByName",
      "width": 100
    },
    {
      "title": "变更原因",
      "dataIndex": "changeReasonName",
      "width": 100
    },
    {
      "title": "变更说明",
      "dataIndex": "changeDescribe",
      "render": "setReasonDescribe",
      "width": 100
    },
    {
      "title": "来源单号",
      "dataIndex": "sourceNumber",
      "render": "setSourceNumber",
      "width": 100
    },
    {
      "title": "来源",
      "dataIndex": "sourceSystem",
      "width": 100
    }
  ],
  "search": [
 
    {
      "name": "status",
      "label": "流水状态",
      "itemType": "select",
      "key": "key",
      "labelKey": "description",
      "showSearch": true,
      "optionFilterProp": "children",
      "allowClear": true,
      "data": "quaStatusEnum"
    },
    {
      "name": "changeType",
      "label": "流水类型",
      "itemType": "select",
      "key": "key",
      "labelKey": "description",
      "showSearch": true,
      "optionFilterProp": "children",
      "allowClear": true,
      "data": "quaChangeTypeEnum"
    },
    {
      "name": "changeReason",
      "label": "变更原因",
      "itemType": "select",
      "key": "key",
      "labelKey": "description",
      "showSearch": true,
      "optionFilterProp": "children",
      "allowClear": true,
      "data": "quaChangeReasonEnum"
    },
    {
      "name": "serialNumber",
      "allowClear": true,
      "label": "流水号"
    }
  ],
  "footer": [
    {
      "label": "导出查询结果",
      "type": "primary",
      // "auth": "retentionMoneyManagementAccountListExport",
      "render": "exportFn"
    },
    {
      "label": "新增流水",
      "type": "primary",
      "events": [
        "onClick:onAddOrEdit"
      ],
      // "auth": "addAccountListBtn"
    },
    {
      "label": "退质保金",
      "type": "primary",
      // "auth": "initiateQualityRefund",
      "render": "onActualReturnMoney"
    }
  ]
}
